import {
  Clock3,
  Navigation2,
  Route
} from "lucide-react";
import {
  WAITING_ROUTE_BANDS,
  getWaitingRouteBand,
  type WaitingRouteBandId
} from "../../config/amapWaitingRouteDemo";
import type { TimedDetourPlan } from "../../services/timedDetourPlanner";

export function TraditionalDesktopWaitingRouteCard({
  bandId,
  onBandChange,
  plan
}: {
  bandId: WaitingRouteBandId;
  onBandChange: (bandId: WaitingRouteBandId) => void;
  plan: TimedDetourPlan;
}) {
  const activeBand = getWaitingRouteBand(bandId);
  const estimatedMinutes = Math.max(1, Math.round(plan.estimatedDurationSeconds / 60));
  const isLoading = plan.status === "loading";
  const routeSourceLabel = plan.dataSource === "amap-live"
    ? "高德实时驾车路线"
    : plan.dataSource === "amap-cache"
      ? "高德道路缓存"
      : plan.dataSource === "amap-snapshot-cache"
        ? "高德道路快照缓存"
      : "高德道路快照";

  return (
    <section
      className="traditional-desktop-map-navigation-card traditional-desktop-waiting-route-card"
      aria-label="绕路等人路线规划"
    >
      <header className="traditional-desktop-waiting-route-card__header">
        <span className="traditional-desktop-waiting-route-card__icon" aria-hidden="true">
          <Clock3 size={34} />
        </span>
        <span>
          <small>绕路等人</small>
          <strong>龙耀路站出发 · {activeBand.label}后回站</strong>
          <em>起点和终点均为2号口，到站即接即走</em>
        </span>
      </header>

      <div
        className="traditional-desktop-waiting-route-card__target"
        aria-label="绕行时长档位"
      >
        {WAITING_ROUTE_BANDS.map((band) => {
          const selected = band.id === bandId;

          return (
            <button
              key={band.id}
              className={selected
                ? "traditional-desktop-waiting-route-card__band traditional-desktop-waiting-route-card__band--active"
                : "traditional-desktop-waiting-route-card__band"}
              type="button"
              aria-pressed={selected}
              disabled={selected}
              onClick={() => onBandChange(band.id)}
            >
              <small>{band.title}</small>
              <strong>{band.label}</strong>
              <span>固定1条路线</span>
            </button>
          );
        })}
      </div>

      <div className="traditional-desktop-waiting-route-card__result">
        <div className="traditional-desktop-waiting-route-card__eta">
          <span>{isLoading ? "规划中" : "预计"}</span>
          <strong>{estimatedMinutes}</strong>
          <em>分钟</em>
        </div>
        <div className="traditional-desktop-waiting-route-card__facts">
          <span><Route size={20} /> 同站绕行 {plan.geometry.summary?.distanceKm.toFixed(1) ?? "--"}km</span>
          <span><Navigation2 size={20} /> 龙耀路2号口返回</span>
          <span><Clock3 size={20} /> {activeBand.label}档</span>
        </div>
      </div>

      <footer className="traditional-desktop-waiting-route-card__footer">
        <span>{plan.routeName}</span>
        <span>{routeSourceLabel}</span>
        <span>{plan.geometry.summary?.trafficLights ?? 0}个红绿灯</span>
        <span>禁左转/掉头</span>
      </footer>
    </section>
  );
}
